// Posture Scan API Types

export interface PostureScanUserData {
  userName: string;
  phoneNumber: string;
  emailId: string;
}

export interface PostureScanImages {
  frontImage: string; // base64 (without data-url prefix)
  sideImage: string; // base64 (without data-url prefix)
}

export interface PostureScanAPIRequest {
  front_image: string;
  side_image: string;
}

export interface PostureAnalysisItem {
  [key: string]: any;
}

export interface PostureImprovementItem {
  [key: string]: any;
}

export interface PostureViewResult {
  score: number;
  analysis: PostureAnalysisItem[];
  improvements: PostureImprovementItem[];
}

export interface PostureScanAPIResponse {
  front_view: PostureViewResult;
  side_view: PostureViewResult;
  timestamp: string;
  request_id: string;
}

export enum PostureScanStep {
  USER_INFO = 'USER_INFO',
  UPLOAD_IMAGES = 'UPLOAD_IMAGES',
  PROCESSING = 'PROCESSING',
  RESULTS = 'RESULTS',
  ERROR = 'ERROR',
}

export interface PostureScanState {
  userData: PostureScanUserData | null;
  images: PostureScanImages | null;
  results: PostureScanAPIResponse | null;
}
